import "jquery";
import * as ko from "knockout";
import { SettlementPricesViewModel } from "../ViewModels/SettlementPricesViewModel";
import { PdfApi } from "../Apis/PdfApi";

export class SettlementPrices {
    private settlementPricesViewModel: SettlementPricesViewModel;
    private $settlementPrices: JQuery;
    pdfApi: PdfApi;

    constructor() {
        this.settlementPricesViewModel = new SettlementPricesViewModel();
        this.$settlementPrices = $("#settlementPrice");
        this.pdfApi = PdfApi.getInstance();

        if (this.$settlementPrices[0]) {
            ko.applyBindings(this.settlementPricesViewModel, this.$settlementPrices[0]);
        }
    }

    init(): void {
        this.settlementPricesViewModel.init();
        this.attachPdfDownloadJquery();
    }

    private attachPdfDownloadJquery(): void {
        const self = this;
        self.$settlementPrices.on('click', '[id *= download]', function (e: any) {
            const id = $(this).attr('id');
            const fileName = $(this).attr('filename');
            const entryNo = Number.parseInt(id.split('download')[1]);
            const company = $(this).attr('company');
            self.pdfApi.downloadFile(entryNo, fileName,company);
        });
    }
}